var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupprimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 6.4V9.4M2.2 3.4H11.8L10.852 11.932C10.8195 12.2256 10.6798 12.4969 10.4598 12.694C10.2397 12.8911 9.95462 13 9.6592 13H4.3408C4.04538 13 3.76034 12.8911 3.54025 12.694C3.32016 12.4969 3.1805 12.2256 3.148 11.932L2.2 3.4ZM4.207 1.6882C4.30405 1.48238 4.45762 1.3084 4.6498 1.18655C4.84198 1.06469 5.06485 0.999997 5.2924 1H8.7076C8.93526 0.999884 9.15825 1.06453 9.35054 1.18639C9.54284 1.30824 9.69651 1.48229 9.7936 1.6882L10.6 3.4H3.4L4.207 1.6882V1.6882ZM1 3.4H13H1ZM5.8 6.4V9.4V6.4Z",
    stroke: "#1F3449",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupprimer);
export default __webpack_public_path__ + "static/media/supprimer.30947a160bf71750d13cbafefee9be43.svg";
export { ForwardRef as ReactComponent };